import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { retrieveSchool, schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import { retrieveClassroom, classroomSlice, selectClassroom } from "../../../redux/classroom/classroomSlice";
import { useAppDispatch } from "../../../app/hooks";
import { LoadState } from "../../../redux/common";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { useEffect } from "react";

interface ClassroomPageTitleProps {
    schoolId: string;
    classroomId: string;
}

const ClassroomPageTitle = ({ schoolId, classroomId }: ClassroomPageTitleProps) => {
    const user = useSelector(selectUser);
    const school = useSelector(selectSchool);
    const classroom = useSelector(selectClassroom);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (school.selected && school.selected.id != schoolId) {
            dispatch(schoolSlice.actions.clean());
        }
        if (school.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveSchool({ schoolId: schoolId }));
        }
    }, [schoolId, school, user]);

    useEffect(() => {
        if (classroom.selected && classroom.selected.id != classroomId) {
            dispatch(classroomSlice.actions.clean());
        }
        if (classroom.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveClassroom({ classroomId: classroomId }));
        }
    }, [classroomId, classroom, user]);


    return (school.selected?.name && classroom.selected?.name) ?
        <Stack sx={{ flexGrow: 1 }}>
            <Typography variant="caption" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
                {school.selected.name}
            </Typography>
            <Typography variant="subtitle1" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
                {classroom.selected.name}{(classroom.selected.year) ? ` - ${classroom.selected.year}` : ""}
            </Typography>
        </Stack>
        : <Typography variant="h6" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
            Sala de aula
        </Typography>;
};

export default ClassroomPageTitle;